<template>
  <div id="loader">
    <div class="dot-windmill"></div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {preloadImages} from '../preload.js'
import {gsap} from 'gsap'

export default {
  name: 'Loader',
  props: ['endLoading', 'arrayImgs'],
  components:{
  },
  data(){
    return {

    }
  },
  methods:{

  },
  mounted(){
    
    preloadImages(this.arrayImgs).then((result) => {
      gsap.to('#loader', {delay: 1, duration: .5, autoAlpha: 0, onComplete: () => {
        this.endLoading()
      }})
    })
  },
  computed:{
   
  },
  watch: {

  }
}
</script>

<style lang="scss">
  #loader {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgb(160, 90, 90);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dot-windmill {
    position: relative;
    top: -10px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #fff;
    color: #fff;
    transform-origin: 5px 15px;
    animation: dotWindmill 2s infinite linear;
  }

  .dot-windmill::before, .dot-windmill::after {
    content: '';
    display: inline-block;
    position: absolute;
  }

  .dot-windmill::before {
    left: -8.66px;
    top: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #fff;
    color: #fff;
  }

  .dot-windmill::after {
    left: 8.66px;
    top: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #fff;
    color: #fff;
  }

  @keyframes dotWindmill {
    0% {
      transform: rotateZ(0deg) translate3d(0, 0, 0);
    }
    100% {
      transform: rotateZ(720deg) translate3d(0, 0, 0);
    }
  }
</style>